import { render, staticRenderFns } from "./DashboardPassageiros.vue?vue&type=template&id=3fe0bc05&"
import script from "./DashboardPassageiros.vue?vue&type=script&lang=js&"
export * from "./DashboardPassageiros.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPassageiros.vue?vue&type=style&index=0&id=3fe0bc05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports